import CustomFetch from "components/API/customFetch";

export const login = async (userName: string, pass: string) => {

    const loginPayload = {
        "login": userName,
        "senha": pass
    };

    return await fetch(`${process.env.REACT_APP_API}/Auth/Login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginPayload)
    })
        .then(async response => {

            return await response.json();
        })

};

export const resetPassword = async (userName: string) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/Auth/AskToResetPassword?email=${userName}`, requestOptions);

        if (!response.ok) {
            var serverResponse = await response.json();
            throw new Error(serverResponse.message, response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    };
}


export const updatePassword = async (newPass: string, email: string, verificationCode: string) => {
    console.log(process.env.REACT_APP_API)
    return await fetch(`${process.env.REACT_APP_API}/Auth/ResetPassword`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email, newPassword: newPass, validationCode: verificationCode })
    })
        .then(async response => {

            return await response.json();
        })

};


export const authenticateGoogleUser = async (userName: string, name: string, imageUrl: string) => {

    //TODO: tirar isso daqui e pegar o token do local storage;
    const loginPayload = {
        "userName": userName,
        "name": name,
        "imageUrl": imageUrl
    };

    return await fetch(`${process.env.REACT_APP_API}/Auth/authenticate-user`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'ApiKey': `${process.env.REACT_APP_APIKEY}`
        },
        body: JSON.stringify(loginPayload)
    })
        .then(response => {
            return response;
        })
        .then(result => {
            return result;
        })
        .catch(error => {
            console.error('Error:', error); // Trata os erros
        });
};

export const register = async (name: string, userName: string, pass: string) => {

    //TODO: tirar isso daqui e pegar o token do local storage;
    const loginPayload = {
        "name": name,
        "UserName": userName,
        "Password": pass
    };

    return await fetch(`${process.env.REACT_APP_API}/Auth/Register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginPayload)
    })
        .then(response => {
            return response;
        })
        .then(result => {
            return result;
        })
        .catch(error => {
            console.error('Error:', error); // Trata os erros
        });
};

export const getUserTier = async () => {
    const requestOptions = {
        method: 'GET',
    };

    try {
        const response = await CustomFetch(`${process.env.REACT_APP_API}/User/tier`, requestOptions);

        if (!response.ok) {
            throw new Error('Erro ao enviar requisição:', response.status);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro:', error);
        throw error;
    };
}

export default login;
